import { cn } from "@/shared/lib";

type HeroAvatarProps = {
  name: string;
  iconUrl: string | null;
  size?: number;
  className?: string;
};

// Иконка героя с явными размерами. Название героя стоит рядом текстом, поэтому `alt` пустой.
// Нет иконки в справочнике — первая буква названия.
export const HeroAvatar = ({ name, iconUrl, size = 40, className }: HeroAvatarProps) => {
  const classes = cn("shrink-0 rounded-lg bg-surface-sunken", className);
  return iconUrl === null ? (
    <span
      aria-hidden="true"
      style={{ width: size, height: size }}
      className={cn(classes, "flex items-center justify-center font-display text-lg text-muted")}
    >
      {name.slice(0, 1)}
    </span>
  ) : (
    <img
      src={iconUrl}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      style={{ width: size, height: size }}
      className={cn(classes, "object-cover")}
    />
  );
};
